// Apolo IDE — PillDropdown (CodeFooter pills).
//
// shad-pro / impeccable / frontend-design pattern:
//   - Fixed height pill (h-7 = 28px) so the row reads as a uniform strip.
//   - Symmetric horizontal padding (px-2.5 = 10px) on both ends -- the
//     icon breathes the same amount on the left as the chevron does on
//     the right ("hug horizontal" = the pill shrinks to its content
//     while keeping visual padding identical on both sides).
//   - Icon (left, textTertiary) + value (font-medium, textPrimary) +
//     chevron (right, textTertiary at 70% alpha) creates a 3-step
//     visual hierarchy: utility -> content -> utility.
//   - Hover lifts the border to borderStrong, focus jumps to accent --
//     both tokens swap between dark and light automatically.

import { ChevronDown } from 'lucide-react';

export default function PillDropdown({ label, value, options, onChange, ariaLabel, Icon }) {
  // When an icon is provided the textual label is treated as decorative
  // (still rendered for screen readers via aria-label on the select).
  const showTextLabel = !Icon && Boolean(label);

  return (
    <label className="group relative inline-flex h-7 items-center gap-1.5 rounded-full border border-apolo-borderSubtle bg-apolo-surface1 px-2.5 text-[11px] leading-none text-apolo-textSecondary transition-colors hover:border-apolo-borderStrong focus-within:border-apolo-accent">
      {Icon && (
        <Icon
          size={12}
          aria-hidden="true"
          className="shrink-0 text-apolo-textTertiary"
        />
      )}
      {showTextLabel && (
        <span className="text-apolo-textTertiary" aria-hidden="true">
          {label}:
        </span>
      )}
      <select
        aria-label={ariaLabel || label || 'opção'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="appearance-none bg-transparent pr-4 text-[11px] font-medium leading-none text-apolo-textPrimary focus:outline-none"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} className="bg-apolo-surface1 text-apolo-textPrimary">
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDown
        size={11}
        aria-hidden="true"
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-apolo-textTertiary opacity-70"
      />
    </label>
  );
}
